import React from 'react';
import { Link } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';

import LoginIcon from '@mui/icons-material/Security';
import MessageIcon from '@mui/icons-material/Message';
import CommunityIcon from '@mui/icons-material/LocationCityRounded';
import VendorIcon from '@mui/icons-material/Storefront';

import { styled } from '@mui/material/styles';

import { logout } from '../../actions/index';
import { useRoleCheck } from '../../hooks/use-role-check';
import type { RootState, AppDispatch } from '../../store';

const NavAppBar = styled(AppBar)({
  backgroundColor: '#577696',
});

const NavToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingLeft: 0,
  paddingRight: 0,
}));

const NavButton = styled(Button)(({ theme }) => ({
  color: 'white',
  textTransform: 'none',
  fontWeight: 300,
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  '& .MuiButton-startIcon': {
    marginRight: theme.spacing(1),
  },
}));

const RouterNavButton = NavButton as React.ComponentType<
  React.ComponentProps<typeof NavButton> & { to?: string; component?: React.ElementType }
>;

const mapStateToProps = (state: RootState) => ({
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  logout: () => dispatch(logout()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type Props = ConnectedProps<typeof connector>;

function NavMenu(props: Props): React.JSX.Element {
  const { isAdmin } = useRoleCheck();

  const handleLogout = (): void => {
    props.logout();
  };

  return (
    <NavAppBar position="static" elevation={0}>
      <NavToolbar>
        <RouterNavButton component={Link} to="/app/chat" startIcon={<MessageIcon />}>
          Ask Stash
        </RouterNavButton>

        {isAdmin() && (
          <>
            <RouterNavButton
              component={Link}
              to="/app/communities"
              startIcon={<CommunityIcon />}
            >
              Communities
            </RouterNavButton>
            <RouterNavButton
              component={Link}
              to="/admin/vendor-edit"
              startIcon={<VendorIcon />}
            >
              Vendor Edit
            </RouterNavButton>
          </>
        )}

        {props.currentUser && (
          <NavButton onClick={handleLogout} startIcon={<LoginIcon />}>
            Log out
          </NavButton>
        )}

        {!props.currentUser && (
          <RouterNavButton component={Link} to="/app/login" startIcon={<LoginIcon />}>
            Log in
          </RouterNavButton>
        )}
      </NavToolbar>
    </NavAppBar>
  );
}

export default connector(NavMenu);
